import React from 'react';
import styled from 'styled-components';
import { percentageFormat } from '../../helpers/formatNumbers';
import Typo from '../Typo';
import Flex from '../Flex';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';

const ProgressOuter = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${(props) => props.theme.colors.NEU_50};
  border-radius: 50px;
  display: flex;
  margin: 5px 0;
`;

const ProgressInner = styled.div`
  width: ${(props) => (props.progress > 5 || props.progress === 0 ? props.progress : 5)}%;
  height: 100%;
  background-color: ${({ theme, $bgcolor }) => $bgcolor || theme.colors.PRIMARY_LIGHT};
  border-radius: 50px;
`;

const Progress = ({ progress, bgcolor, expires }) => {
  const { t, i18n } = useTranslation();

  const locale = i18n.language?.replace('_', '-');
  const isDate = expires && !isNaN(new Date(expires).getTime());
  const formattedExpires = isDate ? new Date(expires).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' }) : null;

  return (
    <div>
      <Flex width='100%' justify='space-between'>
        <Typo.SmallText>{t('users.progress')}</Typo.SmallText>
        <Typo.SmallText $textAlign='center'>{percentageFormat(progress, 0)}%</Typo.SmallText>
      </Flex>
      <ProgressOuter>
        <ProgressInner progress={progress} $bgcolor={bgcolor}></ProgressInner>
      </ProgressOuter>
      {expires && (
        <Flex gap='5'>
          <Icon.Time size='x-small' />
          <Typo.SmallText>{isDate ? t('globals.expirationDate', { expires: formattedExpires }) : t('globals.neverExpires')}</Typo.SmallText>
        </Flex>
      )}
    </div>
  );
};

Progress.displayName = 'Progress';

export default Progress;
